export default __webpack_public_path__ + "static/media/kerala.b6bd143d.webp";